import React from 'react';
import intl from 'react-intl-universal';
import { isMobile } from '../../utils/helpers';

import './index.scss';

const PCFooter = () => {
  return (
    <footer>
      <div className="footer-contact">
        <div className="contact-content">
          <div className="contact-logo" />
          <div className="contact-info">
            <div className="contact-us">
              <h2>{intl.get('footer.company')}</h2>
              <p>{intl.get('footer.address.a1')}</p>
              <p>{intl.get('footer.address.a2')}</p>
              <p>{intl.get('footer.address.a3')}</p>
            </div>
            <div className="contact-link">
              <div className="hr-line" />
              <div className="link-info">
                <h2>{intl.get('footer.join')}</h2>
                <p onClick={() => window.open(intl.get('footer.url'))}>
                  {intl.get('footer.url')}
                </p>
                <h2>{intl.get('footer.contact')}</h2>
                <p>{intl.get('footer.phone')}</p>
                <p>
                  <a href={`mailto:${intl.get('footer.mail')}`}>
                    {intl.get('footer.mail')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-info">
        www.kuaishou.com 2021 @ All Reserved <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank">京ICP备15023266号-136 </a>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038443" rel="noreferrer" target="_blank">  京公网安备11010802038443号</a>
      </div>
      
    </footer>
  );
};

const MobileFooter = () => {
  return (
    <footer className="mobile">
      <div className="contact">
        <div className="logo" />
        <div className="introduction">
          <div className="contact-us">
            <h2>{intl.get('footer.company')}</h2>
            <p>{intl.get('footer.address.a1')}</p>
            <p>{intl.get('footer.address.a2')}</p>
            <p>{intl.get('footer.address.a3')}</p>
          </div>
          <div className="link-info">
            <h2>{intl.get('footer.join')}</h2>
            <p onClick={() => window.open(intl.get('footer.url'))}>
              {intl.get('footer.url')}
            </p>
            <h2>{intl.get('footer.contact')}</h2>
            <p>{intl.get('footer.phone')}</p>
            <p>
              <a href={`mailto:${intl.get('footer.mail')}`}>
                {intl.get('footer.mail')}
              </a>
            </p>
          </div>
        </div>
      </div>
      <div className="info">
        <div>
          <p>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer" target="_blank">京ICP备15023266号-136</a>
          </p>
          <p>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038443" rel="noreferrer" target="_blank">京公网安备11010802038443号</a>
          </p>
          <p>www.kuaishou.com 2021 @ All rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

const Footer = () => {
  return isMobile() ? <MobileFooter /> : <PCFooter />;
};

export default Footer;
